import script from "./HistoryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryComponent.vue?vue&type=script&setup=true&lang=js"

import "./HistoryComponent.vue?vue&type=style&index=0&id=1f67dcc2&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebasedevdemo\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f67dcc2"]])

export default __exports__